import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setAmount(data.amount);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* ignore */ }
      if (tries++ < 8) setTimeout(poll, 1800);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <Shell>
      {status === "checking" && <><Loader2 className="h-14 w-14 animate-spin text-navy" /><h1 className="font-heading text-2xl font-bold text-navy mt-4">Confirming your payment...</h1></>}
      {status === "paid" && <><CheckCircle2 className="h-16 w-16 text-emerald-500" /><h1 className="font-heading text-3xl font-bold text-navy mt-4">Payment Successful!</h1><p className="text-navy/60 mt-2">Thank you{amount ? ` — $${amount.toFixed(2)} received` : ""}. A receipt has been sent to your email.</p></>}
      {status === "pending" && <><Loader2 className="h-14 w-14 animate-spin text-navy" /><h1 className="font-heading text-2xl font-bold text-navy mt-4">Payment processing</h1><p className="text-navy/60 mt-2">This is taking a moment. Check your portal shortly.</p></>}
      {status === "error" && <><XCircle className="h-16 w-16 text-red-500" /><h1 className="font-heading text-2xl font-bold text-navy mt-4">Something went wrong</h1><p className="text-navy/60 mt-2">Please try again from the portal.</p></>}
      <Link to="/portal"><Button className="rounded-full bg-navy hover:bg-navy-dark text-white mt-6" data-testid="payment-back-portal-btn">Back to Portal</Button></Link>
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell>
      <XCircle className="h-16 w-16 text-mustard-dark" />
      <h1 className="font-heading text-3xl font-bold text-navy mt-4">Payment Cancelled</h1>
      <p className="text-navy/60 mt-2">No charge was made. You can try again anytime.</p>
      <Link to="/portal"><Button className="rounded-full bg-navy hover:bg-navy-dark text-white mt-6" data-testid="payment-cancel-back-btn">Back to Portal</Button></Link>
    </Shell>
  );
}

function Shell({ children }) {
  return <div className="min-h-screen bg-cream flex flex-col items-center justify-center text-center px-6">{children}</div>;
}
